export const ondeOPastejoGeraValorContent = {
  heading: "ONDE\nO PASTEJO\nGERA\nVALOR",
  headingAccentWord: "VALOR",
  body:
    "O Pastejo leva mais precisão para dentro da porteira, transformando a rotina da fazenda em mais controle, visibilidade e eficiência operacional. É assim que a gestão passa a acompanhar melhor o que acontece no lote e no pasto, corrigindo desvios com mais agilidade e gerando mais resultados.",
  benefits: [
    "Controle da operação",
    "Visibilidade dos desvios",
    "Precisão no lote e no pasto",
    "Eficiência operacional",
    "Resultado na rotina da fazenda",
  ],
} as const;
